module.exports = __webpack_public_path__ + "static/media/b_house.c2805d97.svg";